import axios from 'axios';
import { API_URL } from '../config/api';

const normalizeAvailability = (data) => ({
  available: Boolean(data?.available ?? data?.isAvailable),
  message: data?.message || '',
});

const registrationService = {
  checkUsername: async (username) => {
    const response = await axios.get(`${API_URL}/auth/check-username`, {
      params: { username },
    });
    return normalizeAvailability(response.data);
  },

  checkEmail: async (email) => {
    const response = await axios.get(`${API_URL}/auth/check-email`, {
      params: { email },
    });
    return normalizeAvailability(response.data);
  },

  checkMobile: async (mobile) => {
    const response = await axios.get(`${API_URL}/auth/check-mobile`, {
      params: { mobile },
    });
    return normalizeAvailability(response.data);
  },

  checkOrganization: async (slug) => {
    const response = await axios.get(`${API_URL}/auth/check-organization`, {
      params: { slug },
    });
    return response.data;
  },
};

export default registrationService;
